var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSettingsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z",
    transform: "translate(-635 -973) translate(635 973)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z",
    transform: "translate(-635 -973) translate(635 973)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M9.954 2.21c1.349-.283 2.742-.284 4.091-.002.182 1.202.902 2.255 1.955 2.862 1.052.609 2.325.705 3.457.261.918 1.028 1.614 2.235 2.043 3.545-.95.759-1.501 1.909-1.5 3.124 0 1.264.586 2.391 1.502 3.124-.432 1.309-1.128 2.515-2.046 3.543-1.132-.444-2.404-.347-3.456.261-1.052.606-1.772 1.66-1.954 2.86-1.349.284-2.742.285-4.091.004-.181-1.203-.9-2.258-1.955-2.865-1.053-.608-2.325-.704-3.457-.26-.918-1.028-1.614-2.236-2.043-3.546.949-.758 1.5-1.907 1.5-3.122.001-1.216-.552-2.366-1.502-3.124.432-1.309 1.128-2.515 2.046-3.543 1.132.444 2.404.347 3.456-.261 1.052-.606 1.772-1.66 1.954-2.86V2.21zM12 15c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3z",
    transform: "translate(-635 -973) translate(635 973)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettingsWhite);
export default __webpack_public_path__ + "static/media/ic-settings-white.99aa592d.svg";
export { ForwardRef as ReactComponent };